// extracted by mini-css-extract-plugin
module.exports = {"nextButton":"style-module--nextButton--E7KhM","nextArrow":"style-module--nextArrow--3sTTL"};